//this makes contenteditable and ngModel play nicely together
angular.module('aprima-core-ui').directive('contenteditable', [function() {
    'use strict';
    var brRegex = /<\s*br\s*\/?>/gm;

    function containsBreaks(str) {
        return brRegex.test(String(str));
    }

    function removeBreaks(str) {
        str =  String(str).replace(brRegex, ' ');
        return str;
    }

    function replaceNbsp(str) {
        // instructions currently written in <div> for easy resizing
        // multiple spaces ' ', results in &nbsp; throwing off char count
        if (!str) return str;
        // var re = new RegExp(String.fromCharCode(160), 'g');
        // return str.replace(re, ' ');
        return str.replace(/&nbsp;/g, ' ');
    }

    /*
    function replaceSpace(str) {
        // multiple spaces ' ' without &nbsp; does not display in <div> correctly
        if (!str) return str;
        return str.replace(/ /g, '&nbsp;');
    }
    */

    return {
        restrict: 'A', // only activate on element attribute
        require: '?ngModel', // get a hold of NgModelController
        link: function(scope, element, attrs, ngModel) {
            if (!ngModel) {
                return; // do nothing if no ng-model
            }

            // Specify how UI should be updated
            ngModel.$render = function() {
                // Bug #24922 - Removed call to (removeBreaks(replaceSpace(ngModel.$viewValue).
                //   This fixed respective sig directions element not wrapping when rendered.
                //   Was able to print and prescribe successfully without any garbage characters.
                //
                // element.html(removeBreaks(replaceSpace(ngModel.$viewValue) || ''));
                element.html(ngModel.$viewValue || '');
            };

            // this logic is based on the angular directive for input[type=text]
            // since it should work basically the same
            element.on('input change', listener);

            ngModel.$formatters.push(function(value) {
                return ngModel.$isEmpty(value) ? value : value.toString();
            });

            function listener(ev) {
                // Bug #25385 - entering '>', displays &gt; as part of the SIG, when returning from the SIG Writer.
                //    element.html() returns the innerHTML which includes &gt;, if '>' was entered.
                //    This resulted in &gt; to be saved with the SigWriterDto.
                //
                //     Using element.text() returns innerText, which includes '>' and not &gt;

                var value = element.text();
                var event = ev && ev.type;

                if(containsBreaks(value)) {
                    value = removeBreaks(value);
                }

                value = replaceNbsp(value);

                // If a control is suffering from bad input (due to native validators), browsers discard its
                // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
                // control's value is the same empty value twice in a row.
                if (ngModel.$viewValue !== value || (value === '' && ngModel.$$hasNativeValidators)) {
                    ngModel.$setViewValue(value, event);
                }
            }
        }
    };
}]);
